'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

require('./index.scss');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _logoOnlyHeader = require('common/components/headers/logo-only-header');

var _logoOnlyHeader2 = _interopRequireDefault(_logoOnlyHeader);

var _captiveFooter = require('common/components/footers/captive-footer');

var _captiveFooter2 = _interopRequireDefault(_captiveFooter);

var _planChoiceArea = require('./plan-choice-area');

var _planChoiceArea2 = _interopRequireDefault(_planChoiceArea);

var _paymentModal = require('../payment-modal');

var _paymentModal2 = _interopRequireDefault(_paymentModal);

var _contactUsLink = require('../contact-us-link');

var _contactUsLink2 = _interopRequireDefault(_contactUsLink);

var _successTestDriveModal = require('./success-test-drive-modal');

var _successTestDriveModal2 = _interopRequireDefault(_successTestDriveModal);

var _couponDisplay = require('../coupon-display');

var _couponDisplay2 = _interopRequireDefault(_couponDisplay);

var _logger = require('common/logger');

var _logger2 = _interopRequireDefault(_logger);

var _planChoiceAreaV = require('./v2/plan-choice-area-v2');

var _planChoiceAreaV2 = _interopRequireDefault(_planChoiceAreaV);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// V2


var ChooseSignupPlan = function (_React$Component) {
    _inherits(ChooseSignupPlan, _React$Component);

    function ChooseSignupPlan(props) {
        _classCallCheck(this, ChooseSignupPlan);

        // Get initial state
        var _this = _possibleConstructorReturn(this, (ChooseSignupPlan.__proto__ || Object.getPrototypeOf(ChooseSignupPlan)).call(this, props));

        _this.onPlanChoice = function (options) {
            // Experiment
            var shouldShowPaymentPage = _this.props.paymentVersion === 2;
            _this.trackPaymentVersion();

            if (shouldShowPaymentPage) {
                _this.redirectToPaymentPage(options);
            } else {
                _this.launchPaymentModal(options);
            }
        };

        _this.redirectToPaymentPage = function (options) {
            var url = '/info/startSignupPlanTrial?guid=' + options.planId + '&period=' + options.timePeriod;
            window.location = url;
        };

        _this.trackPaymentVersion = function () {
            var eventName = void 0;
            // Add Pick a plan version stem
            if (_this.props.version === 1) {
                eventName = 'PickPlan.V1_';
            } else {
                eventName = 'PickPlan.V2_';
            }
            // Add payment version name
            if (_this.props.paymentVersion === 1) {
                eventName += 'PaymentModal';
            } else {
                eventName += 'PaymentPage';
            }

            _logger2['default'].track(eventName);
        };

        _this.onTeamSizeSelect = function (size) {
            _this.setState({
                teamSize: size
            });
        };

        _this.onEnterpriseSuccess = function () {
            _this.setState({
                successModalVisible: true
            });
        };

        _this.renderEnterpriseSuccessModal = function () {
            var modal = void 0;

            if (_this.state.successModalVisible) {
                modal = _react2['default'].createElement(_successTestDriveModal2['default'], null);
            }

            return modal;
        };

        _this.errorMessage = function () {
            var errors;
            if (_this.props.errors) {
                var errorMsg = 'Sorry, we could not process your payment.';
                if (_this.props.errors['payment[submit]']) {
                    errorMsg += ' ' + _this.props.errors['payment[submit]'];
                }
                if (_this.props.errors['payment[cc_number]']) {
                    errorMsg += ' ' + _this.props.errors['payment[cc_number]'];
                }
                if (_this.props.errors['payment[0]']) {
                    errorMsg += ' ' + _this.props.errors['payment[0]'];
                }
                errors = _react2['default'].createElement(
                    'div',
                    { 'data-test-id': 'errors', className: 'row text-center l-padding-v-20' },
                    _react2['default'].createElement(
                        'p',
                        { className: 'c-red' },
                        errorMsg
                    )
                );
            }
            return errors;
        };

        _this.renderCouponArea = function () {
            var couponArea = void 0;

            if (_this.props.coupon) {
                couponArea = _react2['default'].createElement(_couponDisplay2['default'], { couponCode: _this.props.coupon.coupon_code, couponDescription: _this.props.coupon.description });
            }
            return couponArea;
        };

        _this.state = {
            timePeriod: 'Y',
            teamSize: '',
            successModalVisible: false
        };
        return _this;
    }

    _createClass(ChooseSignupPlan, [{
        key: 'launchPaymentModal',
        value: function launchPaymentModal(_ref) {
            var planId = _ref.planId,
                timePeriod = _ref.timePeriod,
                price = _ref.price;

            var attachPoint = HfReactHelper.getRevealAttachPoint('payment_modal', 'medium');
            var rates = this.calculateRates(price, timePeriod);
            _reactDom2['default'].render(_react2['default'].createElement(_paymentModal2['default'], { key: planId,
                planId: planId,
                isFreeTrialEligible: true,
                price: price,
                headerText: 'Start Free Trial',
                timePeriod: timePeriod,
                monthlyExpectedRate: rates.monthlyExpectedRate,
                annualExpectedRate: rates.annualExpectedRate,
                monthlyProratedRate: rates.monthlyProratedRate,
                annualProratedRate: rates.annualProratedRate,
                currentMonthlyRate: rates.currentMonthlyRate,
                currentAnnualRate: rates.currentAnnualRate,
                isTrialing: false,
                proratio: rates.proratio,
                couponCode: this.props.coupon ? this.props.coupon.coupon_code : void 0,
                ccSuffix: void 0,
                ccExpiration: void 0,
                cardHolderName: '',
                name: void 0,
                isApi: false,
                isEventbrite: false,
                termsAccepted: false,
                paymentForm: this.props.paymentForm,
                currentPlanName: void 0 }), attachPoint);
        }
    }, {
        key: 'calculateRates',
        value: function calculateRates(price, timePeriod) {

            var annualExpectedRate = void 0,
                monthlyExpectedRate = void 0;
            if (timePeriod === 'Y') {
                annualExpectedRate = price;
                monthlyExpectedRate = Math.floor(price / 12);
            } else {
                monthlyExpectedRate = price;
                annualExpectedRate = price * 12;
            }

            return {
                monthlyExpectedRate: monthlyExpectedRate,
                annualExpectedRate: annualExpectedRate,
                // These are the same as above, since this is a new plan by definition (DB)
                monthlyProratedRate: monthlyExpectedRate,
                annualProratedRate: annualExpectedRate,
                proratio: 0,
                currentMonthlyRate: 0,
                currentAnnualRate: 0
            };
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            // V2 experiment
            if (this.props.version == 2) {
                if (this.props.paymentVersion == 2) {
                    _logger2['default'].track('ChooseSignupPlan.v2.page');
                } else {
                    _logger2['default'].track('ChooseSignupPlan.v2.modal');
                }

                return this.renderV2();
            } else {
                if (this.props.paymentVersion == 2) {
                    _logger2['default'].track('ChooseSignupPlan.v1.page');
                } else {
                    _logger2['default'].track('ChooseSignupPlan.v1.modal');
                }
            }

            var Blurb = _react2['default'].createElement(
                'div',
                { className: 'm-choose-signup-plan--blurb row text-center l-padding-t-60 l-padding-b-70' },
                _react2['default'].createElement(
                    'div',
                    { className: 'columns' },
                    _react2['default'].createElement(
                        'h1',
                        { className: 'hide-for-small' },
                        'Pick a plan to get started'
                    ),
                    _react2['default'].createElement(
                        'h2',
                        { className: 'hide-for-medium-up' },
                        'Pick a plan to get started'
                    ),
                    _react2['default'].createElement(
                        'h4',
                        { className: 'downsize' },
                        'Choose one of our plans that meets your needs, or',
                        _react2['default'].createElement(_contactUsLink2['default'], { timePeriod: this.state.timePeriod,
                            linkText: ' contact us ',
                            modalHeaderText: 'Contact Us for an Enterprise Plan',
                            onSuccess: this.onEnterpriseSuccess,
                            pricingSource: 'chooseSignupPlan' }),
                        'for an Enterprise Plan'
                    )
                )
            );

            var ChoiceArea = _react2['default'].createElement(_planChoiceArea2['default'], _extends({
                timePeriod: this.state.timePeriod,
                onTimeToggle: function onTimeToggle(value) {
                    _this2.setState({ timePeriod: value });
                },
                onPlanChoice: this.onPlanChoice,
                onEnterpriseSuccess: this.onEnterpriseSuccess
            }, this.props));

            return _react2['default'].createElement(
                'div',
                { className: 'm-choose-signup-plan' },
                _react2['default'].createElement(_logoOnlyHeader2['default'], null),
                Blurb,
                this.errorMessage(),
                this.renderCouponArea(),
                ChoiceArea,
                this.renderEnterpriseSuccessModal(),
                _react2['default'].createElement(_captiveFooter2['default'], null)
            );
        }
    }, {
        key: 'renderV2',
        value: function renderV2() {
            var _this3 = this;

            var Blurb = _react2['default'].createElement(
                'div',
                { className: 'm-choose-signup-plan--blurb row text-center l-padding-t-40' },
                _react2['default'].createElement(
                    'div',
                    { className: 'columns' },
                    _react2['default'].createElement(
                        'h1',
                        { className: 'hide-for-small l-padding-b-70' },
                        'Pick a plan that\'s perfect for you'
                    ),
                    _react2['default'].createElement(
                        'h2',
                        { className: 'v2-subtitle' },
                        'What\'s your team size?'
                    )
                )
            );

            var ChoiceArea = _react2['default'].createElement(_planChoiceAreaV2['default'], _extends({
                timePeriod: this.state.timePeriod,
                onTimeToggle: function onTimeToggle(value) {
                    _this3.setState({ timePeriod: value });
                },
                teamSize: this.state.teamSize,
                onTeamSizeSelect: this.onTeamSizeSelect,
                onPlanChoice: this.onPlanChoice,
                onEnterpriseSuccess: this.onEnterpriseSuccess
            }, this.props));

            return _react2['default'].createElement(
                'div',
                { className: 'm-choose-signup-plan' },
                _react2['default'].createElement(_logoOnlyHeader2['default'], null),
                Blurb,
                this.errorMessage(),
                this.renderCouponArea(),
                ChoiceArea,
                this.renderEnterpriseSuccessModal(),
                _react2['default'].createElement(_captiveFooter2['default'], null)
            );
        }
    }]);

    return ChooseSignupPlan;
}(_react2['default'].Component);

module.exports = ChooseSignupPlan;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/pricing/choose-signup-plan/index.jsx
 ** module id = 1139
 ** module chunks = 0
 **/